import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';
// import registerServiceWorker from './registerServiceWorker';
//import initReactFastclick from 'react-fastclick';
 
//initReactFastclick();
ReactDOM.render(<App />, document.getElementById('root'));

if (module.hot) {
  module.hot.accept(App, () => {
    ReactDOM.render(<App />, document.getElementById('root'))
  })
}

// window.addEventListener('touchmove',
//    function(e) {
//     e.preventDefault();
//   }
// )
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js